import { IProjectScope } from '@common/interfaces/projectScope';
import { EntityState, EntityStore, ActiveState } from '@datorama/akita';
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Injectable } from '@angular/core';
import { ID } from '@common/interfaces/id';
import { Topics } from '@common/interfaces/topics';

export interface ProjectScopeState extends EntityState<IProjectScope, ID>, ActiveState { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.PROJECT_SCOPES, realtimeEntity: 'ProjectScope', idKey: 'projectId', resettable: true })
export class ProjectScopeStore extends EntityStore<ProjectScopeState> {

  constructor() {
    super();
  }
}
